<ng-container [formGroup]="submitForm">
  <mat-form-field>
    <mat-label>{{ 'password-form.text.password' | translate }}</mat-label>
    <input
      [formControlName]="FORM_NAME.PASSWORD"
      [type]="hidePassword ? 'password' : 'text'"
      matInput
      [autocomplete]="'off'"
    />
    <mat-icon
      color="primary"
      (click)="hidePassword = !hidePassword"
      matSuffix
      >{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon
    >
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlPassword"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>

  <lib-spacer></lib-spacer>

  <mat-form-field>
    <mat-label>{{
      'password-form.text.password-confirmation' | translate
    }}</mat-label>
    <input
      [formControlName]="FORM_NAME.PASSWORD_CONFIRM"
      [type]="hidePassword ? 'password' : 'text'"
      matInput
      [autocomplete]="'off'"
    />
    <mat-icon
      color="primary"
      (click)="hidePassword = !hidePassword"
      matSuffix
      >{{ hidePassword ? 'visibility_off' : 'visibility' }}</mat-icon
    >
    <mat-error>
      <lib-error-message-wrapper
        [control]="controlPasswordConfirm"
      ></lib-error-message-wrapper>
    </mat-error>
  </mat-form-field>
</ng-container>
